export const ApiLayhen = {
  auth: '/auth',
  event_address: '/auth/events_address',
  get_product: '/product/get_all',
  event_product: '/product/events_product',
  event_cart: '/cart/events_cart',
  event_order: '/order/events_order',
  get_histories: '/order/get_histories',
  event_order_fplay: '/order/events_order_fplay',
  payment_cod: '/payment/cod',
  promotion_list: '/promotion/get_my_promotion_list',
  apply_promotion: '/promotion/apply_promotion_value',
};
export const ApiHiEcom = {
  auth: '/hi-auth2-api/v1/web/auth',
  // auth: '/hi-ecom-shopping-api/v1/web/auth',
  event_address: '/hi-ecom-shopping-api/v1/web/auth/events-address',
  get_product: '/hi-ecom-shopping-api/v1/web/product/get-all',
  event_product: '/hi-ecom-shopping-api/v1/web/product/events-product',
  event_cart: '/hi-ecom-shopping-api/v1/web/cart/events-cart',
  event_order: '/hi-ecom-shopping-api/v1/web/order/events-order',
  get_histories: '/hi-ecom-shopping-api/v1/web/order/get-histories',
  event_order_fplay: '/hi-ecom-shopping-api/v1/web/order/events-order-fplay',
  event_order_fgame: '/hi-ecom-shopping-api/v1/web/order/events-order-fgame',
  event_order_fsafe: '/hi-ecom-shopping-api/v1/web/order/events-order-fsafe',
  payment_cod: '/hi-ecom-shopping-api/v1/web/payment/cod',
  promotion_list: '/hi-ecom-shopping-api/v1/web/promotion/get-my-promotion-list',
  apply_referral: '/hi-ecom-shopping-api/v1/web/shopping/apply-referral-code',
  apply_promotion: '/hi-ecom-shopping-api/v1/web/promotion/apply-promotion-value',
  list_commission: '/hi-ecom-shopping-api/v1/web/promotion/get-my-commission-wallet',
  affiliate_list: '/hi-ecom-shopping-api/v1/web/promotion/get-afiliate-marketing-list',
  affiliate_list_foxpay: '/hi-ecom-shopping-api/v1/web/promotion/get-voucher-foxpay-list',
  affiliate_click_item: '/hi-ecom-shopping-api/v1/web/promotion/click-item-afiliate-marketing',
  affiliate_apply: '/hi-ecom-shopping-api/v1/web/promotion/get-promotion-code-fr-afiliate-marketing',
  affiliate_apply_foxpay: '/hi-ecom-shopping-api/v1/web/foxpay/get-promotion-code-fr-foxpay'
};
